/// <amd-module name="Pipeline/Analytics/Common/ChartHelper/StackedBarChartDataSelector" />
import { IPipelineAnalyticsTelemetryService } from "Pipeline/Analytics/Common/Telemetry/PipelineAnalyticsTelemetryService";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { IAnalyticsChartProps } from "Pipeline/Analytics/Common/Types";
import { ChartProps, ChartTypesConstants, DataPoint, LabelFormatModes, LegendClickEvent, TooltipLineItem } from "VSS/Features/Charts/Contracts";
import * as Charts_Contracts from "VSS/Features/Charts/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";

export function getStackedBarChartData(pageContext: IVssPageContext, data: IAnalyticsChartProps): ChartProps {
    return {
        title: data.title,
        pageContext: pageContext,
        chartType: ChartTypesConstants.StackedBar,
        suppressAnimation: true,
        xAxis: {
            labelsEnabled: false,
            enabled: false
        },
        yAxis: {
            labelFormatMode: LabelFormatModes.Percentage,
            min: 0,
            max: 100,
            allowDecimals: true,
            markingsEnabled: true
        },
        legend: {
            enabled: false
        },
        hostOptions: {
            height: 120,
            width: 300
        },
        legendClick: (clickEvent: LegendClickEvent) => {
            _publishLegendClickTelemetry(pageContext, data.telemetryArea || "");
            return true;
        },
        series: data.series,

        tooltip: {
            customTooltipHeader: (category: string | number): string | number => {
                return "";
            },
            customTooltipMapping: (points: DataPoint[]) => {
                return _customTooltipMapping(points);
            }
        }
    } as ChartProps;
}

function _customTooltipMapping(points: DataPoint[]): TooltipLineItem[] {
    return points.map(point => {
        const item = {
            styleType: {
                color: point.color,
                type: Charts_Contracts.TooltipLineItemMarkerType.Square
            },
            text: ""
        } as Charts_Contracts.TooltipLineItem;
        const seriesValue = Number(point.values[0]).toLocaleString(navigator.language);

        item.text = `${point.seriesName} : ${seriesValue}%`;

        return item;
    });
}

function _publishLegendClickTelemetry(pageContext: IVssPageContext, data: string): void {
    const telemetryService = pageContext.getService<IPipelineAnalyticsTelemetryService>("IPipelineAnalyticsTelemetryService");
    telemetryService.publishEventWithSingleKey(data, TelemetryConstants.LegendClickCount, 1);
}
